<!--
  - Copyright (c) 2023. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <div>
    <button-component fa-icon="fa-regular fa-trash" background-color="bg-transparent" color="text-red-600 dark:text-red-500" @click="modal = true" />

    <modal-component v-if="modal" v-model="modal">
      <template #body>
        <div class="text-center sm:text-left flex flex-col gap-4">
          <!-- title -->
          <div id="modal-title" class="flex flex-row items-center gap-2">
            <div class="mx-auto flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 bg-red-100">
              <i class="fa-regular fa-triangle-exclamation text-red-600 text-xl"></i>
            </div>

            <div>
              <slot name="title"></slot>
            </div>
          </div>

          <!-- description -->
          <p class="text-sm text-gray-500 dark:text-[#e5e7eb]">
            <slot name="description"></slot>
          </p>
        </div>
      </template>

      <template #footer>
        <button type="button"
                class="inline-flex w-full justify-center border border-transparent bg-red-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:w-auto sm:text-sm"
                @click="deleteEntity"
        >
          Löschen
        </button>
        <button type="button"
                class="button"
                @click="modal = false"
        >
          Abbrechen
        </button>
      </template>
    </modal-component>
  </div>
</template>

<script>
import ButtonComponent from "@/components/ButtonComponent";
import ModalComponent from "@/components/ModalComponent";

export default {
  name: "DeleteComponent",
  components: { ModalComponent, ButtonComponent },
  data() {
    return {
      modal: false
    };
  },
  methods: {
    deleteEntity() {
      this.$emit("delete");
      this.modal = false;
    }
  }
};
</script>

<style scoped>

</style>